import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
// import 'mdb-react-ui-kit/dist/css/mdb.min.css';
// import './styles/tailwind.css';
import 'font-awesome/css/font-awesome.min.css';
// src/App.js or a specific component file
import './assets/css/magnific-popup.css';
import './assets/css/owl.carousel.min.css';
import './assets/css/font-awesome.min.css';
import './assets/css/line-awesome.min.css';
import './assets/css/themify-icons.css';
// src/App.js or a specific component
import './assets/css/slick.css';
import './assets/css/animated-slider.css';


import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

